import React, { useContext } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CharacterList from "./pages/CharacterList";
import CharacterDetail from "./components/CharacterDetail";
import RedeemCodes from "./pages/RedeemCodes";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import EnemyDetail from "./components/EnemyDetail";
import EnemiesList from "./pages/EnemiesList";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { themeSwitcherContext } from "./context/themeContext";
import ItemsList from "./pages/ItemsList";
import EventDetail from "./components/EventDetail";
import EventsList from "./pages/EventsList";
import UpcomingCharactersList from "./pages/UpcomingCharactersList";
import MainStoryList from "./pages/MainStoryList";
import StoryDetails from "./components/StoryDetails";
import EquipmentList from "./pages/EquipmentList";
import GiftsList from "./pages/GiftsList";
import ProfileFramesList from "./pages/ProfilesFramesList";
import Home from "./pages/Home";
import ExWeaponsList from './pages/ExWeaponsList';

const App = () => {
  const themeSwitcher = useContext(themeSwitcherContext);

  const darkTheme = createTheme({
    palette: {
      mode: themeSwitcher.themeMode,
    },
  });
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <Paper>
        <Router>
          <Navbar />
          <Container>
            <Switch>
              <Route exact path="/home" component={Home} />
              <Route exact path="/" component={CharacterList} />

              <Route
                exact
                path="/char-detail/:id"
                component={CharacterDetail}
              />
              <Route exact path="/enemy-detail/:id" component={EnemyDetail} />
              <Route
                exact
                path="/story-details/enemy-detail/:id"
                component={EnemyDetail}
              />
              <Route exact path="/enemies" component={EnemiesList} />

              <Route exact path="/redeem-codes" component={RedeemCodes} />
              <Route exact path="/items" component={ItemsList} />
              <Route exact path="/events-list" component={EventsList} />
              <Route exact path="/event-detail/:id" component={EventDetail} />
              <Route
                exact
                path="/upchar-list"
                component={UpcomingCharactersList}
              />
              <Route exact path="/story" component={MainStoryList} />
              <Route
                exact
                path="/story-details/:id/:inter"
                component={StoryDetails}
              />
              <Route exact path="/equipments-list" component={EquipmentList} />
              <Route exact path="/gifts-list" component={GiftsList} />
              <Route exact path="/frames-list" component={ProfileFramesList} />
              <Route exact path="/exweapons-list" component={ExWeaponsList} />
            </Switch>
          </Container>
          <Footer />
        </Router>
      </Paper>
    </ThemeProvider>
  );
};

export default App;
